import styled from "styled-components";
import {
  mediumFont,
  inputBorderColor,
  whiteColor,
  successColor,
  dangerColor,
  inputBackgroundColor,
  primaryColor,
  labelColor,
  newsecondaryColor,
  regularFont,
  infoBGColor,
  semiBoldFont,
  newsecondaryHoverColor,
} from "@app/styles";

export const Layout = styled.div`
  width: 100%;
  height: calc(100vh - 0px);
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #8bc53f 0%, #42ba7d 50%, #35c9c0 100%);
  overflow: hidden;
  position: relative;
  .bottom-right-image {
    position: fixed;
    bottom: 0;
    right: 0;
  }
  &.alt{
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    z-index: 20;             
  }
  @media print{
    margin-top: -100px !important;
    div {
      margin-top: 40px !important;
    }
    background: linear-gradient(180deg, #8bc53f 0%, #42ba7d 50%, #35c9c0 100%) !important;
    
  }
`;

export const PageHeader = styled.div`
  min-height: 100px;
  display: flex;
  align-items: center;
`;

export const LogoSec = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  &.center-aligned {
    justify-content: center;
  }
  img {
    cursor: pointer;
  }
`;

export const ContentHolder = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  &.aligned-center {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &.flexed {
    flex: 1;
  }
`;

export const PopupDialog = styled.div`
  width: 800px;
  background-color: ${whiteColor};
  border-radius: 8px;
  padding: 35px 80px;
  margin: 0% auto;
  text-align: center;
  position: relative;
  z-index: 2;
  &.form-container {
    width: 100%;
    max-width: 900px;
    padding: 48px;
    text-align: left;
    margin-top: 90px;
    margin-bottom: 30px;
    z-index: 1;
    &.max-w-1040{
      max-width:1040px;
      padding:38px;
    }
    @media (max-width: 575px) {
      width: 100%;
      max-width: calc(100vw - 16px);
      padding: 32px;
      margin: 24px auto;
    }
    form{
      position: relative;
      .back-icon{
        height: 40px;
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: all 0.3s ease;
        &:hover{
          transform: translateX(-5px);
        }
      }
    }
  }
  &.w-700 {
    width: 700px;
  }
  &.h-300 {
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .top-left-image {
    position: absolute;
    top: -75px;
    left: -175px;
    z-index: -1;
    @media (max-width: 575px) {
      top: -40px;
      left: -100px;
    }
  }
  .left-aligned-image {
    position: absolute;
    top: 50%;
    left: -100px;
    height: 600px;
    transform: translateY(-50%);
  }
  .right-aligned-image {
    position: absolute;
    top: 50%;
    height: 600px;
    right: -132px;
    transform: translateY(-50%);
  }
  .page-left-aligned-image {
    position: absolute;
    top: 50%;
    left: -170px;
    transform: translateY(-50%);
  }
  .page-right-aligned-image {
    position: absolute;
    top: 50%;
    right: -170px;
    transform: translateY(-50%);
  }
  &.centered {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  &.custom-message {
    @media (max-width: 575px) {
      width: 375px;
      padding: 32px;
      margin: 0;
      .primary-header {
        padding-left: 100px;
        margin-top: 40px !important;
      }
      .content {
        padding-left: 100px;
        margin-bottom: 40px !important;
      }
      .right-aligned-image {
        display: none;
      }
      .left-aligned-image {
        top: 16px;
        left: 32px;
        width: 100px;
        transform: unset;
      }
    }
    &.welcome-parent{
      min-height: 350px;
    }
  }
  @media (max-width: 575px){
    width: calc(100vw - 16px) !important;
    padding: 32px !important;
  }
`;

export const FormHeader = styled.div`
display: flex;
align-items: center;
&.mb-3{
  margin-bottom: 24px;
}
`

export const FormTitle = styled.div`
flex: 1;
display: flex;
align-items: center;
&.justify-center{
  justify-content: center;
}
`

export const FormContainer = styled.div`
  width: 700px;
  margin: 80px auto;
  background-color: ${whiteColor};
  border-radius: 8px;
  padding: 48px 90px;
  position: relative;
  .top-left-image {
    position: absolute;
    top: -75px;
    left: -175px;
    z-index: -1;
    @media (max-width: 575px) {
      top: -40px;
      left: -100px;
    }
  }
`;

export const FormGroupWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  &:not(:last-of-type) {
    padding-bottom: 24px;
    border-bottom: 1px solid ${inputBorderColor};
    margin-bottom: 24px;
  }
  &.no-border {
    padding-bottom: 0;
    border: none;
  }
`;

export const FormFlexWrapper = styled.div`
  display: flex;
  margin: 0 -8px 16px;
  position: relative;
  &.mb-0 {
    margin-bottom: 0 !important;
  }
  .child {
    margin: 0 8px;
  }
  .only-child {
    width: calc(100% - 16px);
  }
  &.two-child-layout {
    .child {
      width: calc(100% / 2 - 16px);
      @media (max-width: 575px) {
        width: calc(100% - 16px);
        &:not(:last-child){
          margin-bottom: 16px;
        }
      }
    }
  }
  &.three-child-layout {
    .child {
      width: calc(100% / 3 - 16px);
    }
  }
  @media (max-width: 575px) {
    flex-direction: column;
  }
  .ellipsis{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 87%;
  }
`;

export const FormWrapper = styled.div`
  width: 600px;
  padding: 32px 64px;
  .form-header {
    font-family: "Filson";
    font-size: 24px;
    font-weight: 500;
    margin: 0 0 20px;
  }
  &.alt-padding {
    padding: 24px 40px;
  }
  @media (max-width: 575px) {
    width: 100%;
    padding: 24px !important;
  }
`;

export const Error = styled.span`
  display: block;
  font-size: 12px;
  ${mediumFont};
  color: ${dangerColor};
  margin: 4px 0 0;
  &.checkbox-error {
    margin: 8px 0 0;
  }
`;

export const FlexWrapper = styled.div`
  display: flex;
  &.align-center {
    align-items: center;
  }
  &.justify-center {
    justify-content: center;
  }
  &.justify-end {
    justify-content: flex-end;
  }
  &.justify-between {
    justify-content: space-between;
  }
  &.justify-start {
    flex-direction: column;
  }
  &.flex-start-on-mobile {
    @media (max-width: 575px) {
      align-items: flex-start;
    }
  }
  &.w-300{
    width: 300px;
    &.centered{
      margin-left: auto;
      margin-right: auto;
    }
  }
  &.w-200{
    width: 200px;
  }
  &.col-layout{
    flex-direction: column;
  }
  &.wrap-items{
    flex-wrap: wrap;
  }
  @media (max-width: 575px) {
    flex-direction: column;
    &.row-on-mobile {
      flex-direction: row;
    }
  }
`;

export const DropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

export const SelectCustomStyles: any = {
  control: (styles: any, state: any) => {
    return {
      ...styles,
      borderWidth: "2px",
      borderRadius: "6px",
      background: state.isFocused ? whiteColor : inputBackgroundColor,
      "border-color": `${state.isFocused ? primaryColor : inputBorderColor
        } !important`,
      "box-shadow": "none",
      "margin-bottom": "0",
      "min-height": "44px",
    };
  },
  menu: (styles: any, state: any) => {
    return {
      ...styles,
      "z-index": '20'
    }
  },
  valueContainer: (styles: any, state: any) => {
    return {
      ...styles,
      padding: '0 16px'
    }
  },
  multiValue: (styles: any, state: any) => {
    return {
      ...styles,
      backgroundColor: "#F9FCFF",
      border: `1.5px solid ${newsecondaryColor} `,
      borderRadius: "4px",
      paddingTop: "1px",
    };
  },
  multiValueLabel: (styles: any, state: any) => ({
    ...styles,
    color: `#33403E`,
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "400",
  }),
  multiValueRemove: (styles: any, state: any) => ({
    ...styles,
    color: `rgb(187,187,187)`,
    svg: {
      height: "16px",
      width: "16px",
    },
    ":hover": {
      backgroundColor: "none",
      color: "red",
    },
  }),
};

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  &.top-right-positioned{
    position: absolute;
    top: 16px;
    right: 16px;
  }
`;

export const ActionButton = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  cursor: pointer;
  &.success {
    background-color: ${successColor};
  }
  &.danger {
    background-color: ${dangerColor};
  }
  &:not(:last-child) {
    margin-right: 8px;
  }
`;

export const TitleIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CommonLabel = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  font-family: "Filson";
  line-height: 1.25;
  margin: 0 0 4px;
  &.alt {
    margin: 0;
    line-height: 26px;
  }
  &.fs-16 {
    font-size: 16px;
  }
  &.label-color {
    color: ${labelColor};
  }
`;
export const StateLabel = styled.label`
  display: block;
  font-family: "Filson";
  font-size: 14px;
  letter-spacing: 0.03em;
  color: ${labelColor};
  ${mediumFont};
  line-height: 1.25;
  margin-bottom: 4px;
`

export const SubscriptionBox = styled.div`
  border: 1.5px solid #00be9a;
  border-radius: 8px;
  background: #f9fcff;
  padding: 10px;
`;

export const TextCenter = styled.div`
  text-align: center;
  line-height: 1.5;
`;

export const ElementOrder = styled.div`
  display:flex;
  .mt{
    margin-top:13px;
    margin-left:2px;
  }
`

export const PaymentInstructions = styled.div`
background-color: ${infoBGColor};
border-radius: 6px;
padding: 16px;
margin-bottom: 24px;
p{
  font-size: 14px;
  line-height: 1.45;
}
`

export const EmptyContainer = styled.div`
width: 100%;
text-align: center;
margin-top: 10%;
margin-bottom: 10%;
display: flex;
flex-direction: column;
align-items: center;
top: 50%;
left: 0;
transform: translateY(-50%);
&.generate-password-spinner{
  width:40px;
  padding-bottom:10px;
};
svg{
  margin-bottom: 16px;
}
&.without-pos{
  position: unset;
  top: unset;
  left: unset;
  transform: unset;
  padding: 100px 0;
  &.alt-padding{
    padding: 40px 0;
  }
}
&.without-pos1{
  position: unset;
  top: unset;
  left: unset;
  transform: unset;
  padding: 175px 0;
  &.alt-padding{
    padding: 40px 0;
  }
  span{
    font-size:14px;
  }
};

`

export const DefaultMessage = styled.p`
font-size: 14px;
${mediumFont};
color: ${labelColor};
margin: 0;
@media (max-width: 575px){
  text-align: center;
}
`

export const ButtonLink = styled.a`
  height: 50px;
  padding: 0 24px;
  background-color: ${newsecondaryColor};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  ${semiBoldFont};
  color: ${whiteColor};
  text-decoration: none;
  &:hover{
    background-color: ${newsecondaryHoverColor};
  }
`

export const ButtonHolder = styled.div`
&.disabled{
  cursor: not-allowed !important;
  opacity: 0.5;
  button{
    pointer-events: none;    
  }
}
`
export const LoggedUserName = styled.a`
  padding: 9px 20px;
  font-family: Poppins, sans-serif;
  font-size: 16px;
  line-height: 26px;
  font-weight: 500;
  text-align: center;
  color: #33403e;
  align-self: flex-start;
  cursor: pointer;
  text-transform: capitalize;
  text-decoration: none;
  &:hover{
    color: #3fbfad;
  }
`

export const SignUpBtn = styled.a`
  display: inline-block;
  padding: 8px 24px;
  border: 1px solid transparent;
  border-radius: 6px;
  background-color: #3fbfad;
  font-size: 16px;
  font-weight: 500;
  color: #f6f6f6;
  line-height: 1.5;
  text-decoration: none;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover{
    background-color: transparent;
    border-color: #3fbfad;
    color: #3fbfad;
  }
  &.user-logged-in{
    background-color: transparent;
    border: 1px solid transparent;
    color: #33403e;
    width: 112px;
    padding-left: 8px;
    padding-right: 8px;
    &:hover{
      color: #3fbfad;
    }
  }
`
export const SpinnerSpan = styled.span`
position: absolute;
right: 7px;
bottom: 0px;
`
export const GenaratePassword = styled.div`
  .separator{
    width: 100%;
    text-align: center;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    display: block;
    margin: 24px 0;
    position: relative;
    &::before {
      content: "";
      width: 100%;
      max-width: 44%;
      height: 1px;
      background: #DFE3E9;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translate(0 , -50%);
    }
    &::after {
      content: "";
      width: 100%;
      max-width: 44%;
      height: 1px;
      background: #DFE3E9;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translate(0 , -50%);
    }
  }
`